(function($){
  $(document).ready(function(){
    if($('.print_popup').length){
      
      $(document).on('click', '.print_popup', function(e){
        data_popup = $(this).attr('data-popup');
        $(data_popup).fadeIn('slow');
        e.preventDefault();
      });
      
      $(document).on('click', '.icon-popup-close', function(e){
        data_popup = $(this).attr('data-popup');
        $(data_popup).fadeOut('slow');
        e.preventDefault();
      });
    }//end if
  });
})(jQuery);